/**
 * RoadmapPage — the authed `/roadmap` route (SPEC-keystone-roadmap-page-2026-07-26 R2).
 *
 * Rendered STANDALONE (full-screen), NOT inside DashboardLayout. The roadmap is a
 * dark, full-bleed, immersive journey page; boxed inside the light admin shell it
 * read as "a landing page trapped in the app frame" — hard white sidebar/header
 * seams down/across a near-black page, and a right-shifted composition. Standalone
 * lets it own the whole viewport (and scroll on the window, which its sticky filter
 * bar + scroll reveals expect). It is still auth-gated by `ProtectedRoute` in
 * App.tsx; a small fixed "Back" control returns to the app.
 *
 * The tieback "Report feedback" CTA opens the same app-wide feedback dialog the
 * header button uses (ReportFeedbackButton) — mounted here in controlled mode with
 * its own trigger hidden, since this chrome-less route has no header to carry it.
 *
 * All presentation lives in `./roadmap/RoadmapPageLayout.tsx` (presentation-only,
 * content via props) so a future public route can reuse the layout unchanged.
 * Content is curated + static, sourced from R1's `roadmap-content.ts`.
 */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReportFeedbackButton } from '@/components/feedback/ReportFeedbackButton';
import { RoadmapPageLayout } from './roadmap/RoadmapPageLayout';
import {
  roadmapHero,
  roadmapHeroVisual,
  roadmapShipped,
  roadmapBuilding,
  roadmapHorizon,
  roadmapTieback,
} from './roadmap/roadmap-content';

export function RoadmapPage() {
  const navigate = useNavigate();
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  return (
    <div className="roadmap-route">
      <button
        type="button"
        className="roadmap-back"
        onClick={() => navigate(-1)}
        aria-label="Back to Keystone"
      >
        ← Back
      </button>
      {/* App-wide feedback dialog, controlled + trigger hidden — the tieback CTA
          below opens it (this route has no header to host the built-in button). */}
      <ReportFeedbackButton open={feedbackOpen} onOpenChange={setFeedbackOpen} hideTrigger />
      <RoadmapPageLayout
        hero={roadmapHero}
        heroVisual={roadmapHeroVisual}
        shipped={roadmapShipped}
        building={roadmapBuilding}
        horizon={roadmapHorizon}
        tieback={roadmapTieback}
        onTiebackCtaClick={() => setFeedbackOpen(true)}
      />
    </div>
  );
}
